import { Component, OnInit, OnDestroy, Renderer2, inject } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);

  private resizeCleanup?: () => void;
  private scrollCleanup?: () => void;

  ngOnInit() {
    if (typeof window !== 'undefined' && window.visualViewport) {
      const viewport = window.visualViewport;

      // Zentralisierte Update-Funktion
      const updateHeight = () => {
        const currentHeight = viewport.height;
        document.documentElement.style.setProperty('--visual-viewport-height',`${currentHeight}px`);
        window.scrollTo(0, 0);
      };

      this.resizeCleanup = this.renderer.listen(viewport, 'resize', updateHeight);
      this.scrollCleanup = this.renderer.listen(viewport, 'scroll', updateHeight);

      updateHeight();
    }
  }

  ngOnDestroy() {
    if (this.resizeCleanup) this.resizeCleanup();
    if (this.scrollCleanup) this.scrollCleanup();
  }

}
